import { useCallback, useEffect } from 'react';
import I18N from '@leverege/i18n';
const ns = 'molten.Head.Support';
const {
  t,
  tIcon
} = I18N.ns(ns);
export default function Head() {
  const resolveTranslation = useCallback((key, dVal = null, isIcon = false) => {
    const fullKey = `${ns}.${key}`;
    const val = isIcon ? tIcon(key) : t(key);
    return val === fullKey ? dVal : val;
  }, []);
  const icon = resolveTranslation('favicon', null, true);
  const title = resolveTranslation('title');
  useEffect(() => {
    if (icon && icon?.startsWith('https://')) {
      const link = document.querySelector("link[rel~='icon']") || document.createElement('link');
      link.rel = 'icon';
      link.href = icon;
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  }, [icon]);
  useEffect(() => {
    if (title && document.title !== title) {
      document.title = title;
    }
  }, [title]);
  return null;
}